import React from 'react'

const Street = () => {
    return (
        <div className='page-height'>
            Street - COMING SOON
        </div>
    )
}

export default Street